module.exports = __webpack_public_path__ + "static/img/landing3.b8134ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing3.png
// module id = gza/
// module chunks = 1